import React from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import AddRecurringDepositCharge from "./AddRecurringDepositCharge";
import ApproveAccount from "./ApproveAccount";
import UndoApprovalRecurringDepositAcc from "./UndoApproval";
import ActivateRecurringDepositAcc from "./ActivateRecurringDepositAcc";
import RejectRecurringDepositAcc from "./RejectRecurringDepositAcc";
import PrematureCloseRecurringDepositAcc from "./PrematureCloseRecurringDepositAcc";
import DepositRecurringDepositAcc from "./DepositRecurringDepositAcc";
import ModifyAppRecurringDepositAcc from "./ModifyAppRecurringDepositAcc";
import WithdrawnByApplicantRecurringDepositAcc from "./WithdrawnByApplicantRecurringDepositAcc";
import WithdrawRecurringDepositAcc from "./WithdrawRecurringDepositAcc";
import TransferOnFundsOnRecurringDepositAcc from "./TransferFundsRecurringDeposit";
const RecurringDepositsMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();
  console.log(state, "state");
  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "add charge":
        return <AddRecurringDepositCharge userData={userData} />;
      case "undo approval":
        return <UndoApprovalRecurringDepositAcc userData={userData} />;
      case "approve":
        return <ApproveAccount userData={userData} />;
      case "activate":
        return <ActivateRecurringDepositAcc userData={userData} />;
      case "reject":
        return <RejectRecurringDepositAcc userData={userData} />;
      case "premature close":
        return <PrematureCloseRecurringDepositAcc userData={userData} />;
      case "modify application":
        return <ModifyAppRecurringDepositAcc userData={userData} />;
      case "deposit":
        return <DepositRecurringDepositAcc userData={userData} />;
      case "withdrawn by applicant":
        return <WithdrawnByApplicantRecurringDepositAcc userData={userData} />;
      case "withdraw":
        return <WithdrawRecurringDepositAcc userData={userData} />;
      case "transfer funds":
        return <TransferOnFundsOnRecurringDepositAcc userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(RecurringDepositsMainActionPage);
